import Image from 'next/image'
import type { ReactNode } from 'react'
import { cn } from '@/components/ui'
import { Titre } from './Titre'

/**
 * L'écran vide de la DA 2027 : un aplat rose, un titre court, une phrase qui
 * dit **pourquoi c'est vide et quand ça se remplira**, et un lien seulement
 * s'il mène quelque part — jamais de bouton inactif (`AGENTS.md`).
 *
 * L'illustration (pack 2027, `/brand/stickers/`) se pose dans le coin, sur le
 * rose : c'est permis. Les textes de référence sont dans
 * `../oasis-2027-maquettes/variantes.html`.
 */
export function EtatVide({
  titre,
  accent,
  illustration,
  action,
  children,
  className,
}: {
  titre: string
  accent?: string
  illustration?: string
  action?: ReactNode
  children: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-[24px] bg-rose p-6 pr-[132px] oasis:p-8 oasis:pr-[180px]',
        className,
      )}
    >
      <Titre as="h3" accent={accent} className="text-[28px] oasis:text-[32px]">
        {titre}
      </Titre>
      <p className="mt-3 max-w-[34em] text-[15px] text-ink">{children}</p>
      {action && <div className="mt-5">{action}</div>}
      {illustration && (
        <Image
          src={illustration}
          alt=""
          width={320}
          height={320}
          className="u-illustration absolute right-3 bottom-2 w-[112px] rotate-6 oasis:w-[150px]"
        />
      )}
    </div>
  )
}
